import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BillingAddress } from '~core/models/customer-supplier.model';

@Component({
  selector: 'billing-address',
  standalone: false,
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BillingAddressComponent {
  billingAddress = input<BillingAddress | undefined>(undefined);
  nif = input<string | undefined>(undefined);
  idu = input<string | undefined>(undefined);
  active = input<boolean>(false);
}
